import { styled, Grid, Chip } from '@mui/material';

export const OfferAssetImage = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: '100%'
}));

export const StickyGrid = styled(Grid)(({ theme }) => ({
  position: 'sticky',
  top: theme.spacing(10)
}));

export const StickyGridWrapper = styled(StickyGrid)(({ theme }) => ({
  background: theme.palette.white.main,
  boxShadow: `${theme.spacing(1)} 0 0 ${theme.palette.white.main}`,
  [theme.breakpoints.down('lg')]: {
    paddingBottom: theme.spacing(2)
  }
}));

export const RequiredFieldsWrapper = styled('div', { shouldForwardProp: prop => !['hasErrors'].includes(prop) })(
  ({ theme, hasErrors }) => ({
    background: '#ffffff',
    border: '2px solid black',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    borderColor: hasErrors ? theme.palette.error.main : theme.palette.success.main,
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(2)
    }
  })
);

export const RequiredFieldsTitle = styled(Grid, { shouldForwardProp: prop => !['hasErrors'].includes(prop) })(({ theme, hasErrors }) => ({
  fontWeight: '700',
  fontSize: '18px',
  color: hasErrors ? theme.palette.error.main : theme.palette.success.main
}));

export const RequiredFieldItemsWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1)
}));

export const RequiredFieldsChip = styled(Chip)(() => ({
  height: 'auto',
  '& .MuiChip-label': {
    whiteSpace: 'break-spaces'
  }
}));

export const RequiredFieldsHelpDescription = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.spacing(0.5)
}));

export const RequiredFieldsNoFieldsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const OfferAssetOptionsWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));
